module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "ma-0 pa-0",
    attrs: {
      "indeterminate": true,
      "height": 3,
      "color": "primary"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55292238","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuexLoader.vue
// module id = 1427
// module chunks = 9